import { CheckCircle2 } from "lucide-react";

/**
 * Composant de navigation par étapes cliquable
 * Permet de revenir aux étapes précédentes en cliquant dessus
 */
export default function StepNavigation({
  steps,
  currentStep,
  onStepClick,
  className = ""
}) {
  if (!steps || steps.length === 0) return null;
  
  return (
    <div className={`flex items-center justify-between ${className}`}>
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep === stepNumber;
        const isCompleted = currentStep > stepNumber;
        const isClickable = isCompleted;

        return (
          <div key={`step-${stepNumber}`} className="flex items-center">
            <button
              type="button"
              onClick={() => isClickable && onStepClick(stepNumber)}
              disabled={!isClickable}
              className={`
                flex items-center justify-center w-10 h-10 rounded-full 
                font-semibold transition-all duration-300
                ${isActive 
                  ? 'bg-[#1A4D2E] text-white ring-4 ring-[#1A4D2E]/20' 
                  : isCompleted 
                    ? 'bg-[#81B29A] text-white cursor-pointer hover:bg-[#6a9c84] hover:scale-105'
                    : 'bg-slate-200 text-slate-400 cursor-not-allowed'
                }
              `}
              data-testid={`step-nav-${stepNumber}`}
            >
              {isCompleted ? (
                <CheckCircle2 className="h-5 w-5" />
              ) : (
                stepNumber
              )}
            </button>

            {index < steps.length - 1 && (
              <div
                className={`hidden sm:block w-8 md:w-16 h-0.5 mx-1 md:mx-2 transition-colors duration-300 ${
                  isCompleted ? 'bg-[#81B29A]' : 'bg-slate-200'
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
